import { useContext, useEffect, useState } from 'react';

import dynamicClass from 'clsx';

import Checkbox from '@/components/atoms/checkbox/checkbox';
import GlobalContext from '@/contexts/globalContext';
import { IRequestFormShiftProps } from '@/interfaces/qanty';
import listTypeDoc from '@/utils/typeDoc.json';
import { validateNullOrUndefined } from '@/utils/validateNullOrUndefined';

import Input from '../../atoms/input/input';
import Select from '../../atoms/select/select';
import './requestFormShift.scss';

const RequestFormShift = ({
  contentInfo,
  register,
  setValue,
  handleSubmit,
  errors,
  getValues,
  reset,
  setIsChecksReady,
}: IRequestFormShiftProps) => {
  const formInfo = contentInfo.referencias[1];
  const { gigyaContext } = useContext(GlobalContext);
  const [isLogged, setIsLogged] = useState(false);
  const [isActiveTermsOne, setIsActiveTermsOne] = useState(false);
  const [isActiveTermsTwo, setIsActiveTermsTwo] = useState(false);
  const [docName, setDocName] = useState('');

  const handleCheckbox = (type: any) => {
    if (type === 'one') {
      setIsActiveTermsOne(!isActiveTermsOne);
      setValue('termsOne', !isActiveTermsOne);
    } else {
      setIsActiveTermsTwo(!isActiveTermsTwo);
      setValue('termsTwo', !isActiveTermsTwo);
    }
  };

  const checkboxClass = dynamicClass({
    'm-request-form-shift__checkbox__size': true,
    'm-request-form-shift__checkbox--error': errors.terms,
  });

  const onAcceptTerms = (type): any => {
    if (type === 'one') {
      setIsActiveTermsOne(!isActiveTermsOne);
      setValue('termsOne', !isActiveTermsOne);
    } else {
      setIsActiveTermsTwo(!isActiveTermsTwo);
      setValue('termsTwo', !isActiveTermsTwo);
    }
  };

  useEffect(() => {
    const valueTerms = getValues('terms');
    setValue('terms', valueTerms ?? false);
    if (!gigyaContext?.gigyaAccount) {
      setIsLogged(false);
      reset();
      return;
    }
    setIsLogged(true);

    const userTypeDoc = listTypeDoc.find(
      (type) => type.typaDocSAP === gigyaContext?.gigyaAccount?.data?.docType,
    );
    setDocName(userTypeDoc?.name);
    setValue(
      'name',
      validateNullOrUndefined(
        `${gigyaContext?.gigyaAccount?.profile?.firstName} ${gigyaContext?.gigyaAccount?.data?.secondName}`,
      ),
    );
    setValue(
      'lastName',
      validateNullOrUndefined(
        `${gigyaContext?.gigyaAccount?.profile?.lastName} ${gigyaContext?.gigyaAccount?.data?.secondLastName}`,
      ),
    );
    setValue('documentType', userTypeDoc);
    setValue('docNumber', validateNullOrUndefined(gigyaContext?.gigyaAccount?.data?.docNumber));
  }, [gigyaContext?.gigyaAccount]);

  useEffect(() => {
    if (isActiveTermsOne === true && isActiveTermsTwo === true) {
      setIsChecksReady(true);
    } else {
      setIsChecksReady(false);
    }
  }, [isActiveTermsOne, isActiveTermsTwo]);

  const listTypesDocsQanty = (typeDoc?: string) => {
    const typesAccept = {
      CO1C: 'CC',
      CO1T: 'TI',
      CO1E: 'CE',
    };
    return typeDoc ? typesAccept[typeDoc] : 'NU';
  };

  useEffect(() => {
    if (gigyaContext?.gigyaAccount) {
      setIsChecksReady(true);
    }
  }, [gigyaContext?.gigyaAccount]);

  return (
    <form onSubmit={handleSubmit} className="m-request-form-shift">
      {formInfo.referencias && formInfo.referencias[0] && (
        <div className="m-request-form-shift__input">
          <Input
            label={formInfo.referencias[0].titulo ? formInfo.referencias[0].titulo : 'Nombres'}
            name="name"
            maxLength="100"
            type="text"
            square
            placeholder={
              formInfo.referencias[0].subtitulo
                ? formInfo.referencias[0].subtitulo
                : 'Escribe tus nombres'
            }
            register={register}
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
              pattern: {
                value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                message: 'No se permiten caracteres especiales',
              },
              minLength: {
                value: 2,
                message: 'El nombre debe tener al menos 2 caracteres',
              },
            }}
            setValue={setValue}
            required
            error={errors.name}
            disabled={isLogged}
          />
        </div>
      )}

      {formInfo.referencias && formInfo.referencias[1] && (
        <div className="m-request-form-shift__input">
          <Input
            label={formInfo.referencias[1].titulo ? formInfo.referencias[1].titulo : 'Apellidos'}
            name="lastName"
            maxLength="100"
            type="text"
            square
            placeholder={
              formInfo.referencias[1].subtitulo
                ? formInfo.referencias[1].subtitulo
                : 'Escribe tus apellidos'
            }
            register={register}
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
              pattern: {
                value: /^[A-Za-zÀ-ÿ ,.'-]+$/,
                message: 'No se permiten caracteres especiales',
              },
              minLength: {
                value: 2,
                message: 'El nombre debe tener al menos 2 caracteres',
              },
            }}
            setValue={setValue}
            required
            error={errors.lastName}
            disabled={isLogged}
          />
        </div>
      )}

      {formInfo.referencias && formInfo.referencias[2] && (
        <div className="m-request-form-shift__input">
          <Select
            label={
              formInfo.referencias[1].titulo ? formInfo.referencias[2].titulo : 'Tipo de documento'
            }
            name="documentType"
            id="m-request-form__document-type"
            register={register}
            options={
              formInfo.referencias[2].listaJson
                ? formInfo.referencias[2].listaJson
                : [
                    {
                      name:
                        formInfo.referencias[2] && formInfo.referencias[2].subtitulo
                          ? formInfo.referencias[2].subtitulo
                          : 'Selecciona un tipo de documento',
                      value: '',
                    },
                  ]
            }
            setValue={setValue}
            square
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
            }}
            defaultValue={{
              name:
                formInfo.referencias[2] && formInfo.referencias[2].subtitulo
                  ? formInfo.referencias[2].subtitulo
                  : 'Selecciona un tipo de documento',
              value: '',
            }}
            {...(docName && {
              forceChangeValue: {
                name: docName,
                value: listTypesDocsQanty(gigyaContext?.gigyaAccount?.data.docType),
              },
            })}
            error={errors.documentType}
            required
            disabled={isLogged}
          />
        </div>
      )}
      {formInfo.referencias && formInfo.referencias[3] && (
        <div className="m-request-form-shift__input">
          <Input
            label={
              formInfo.referencias[3].titulo
                ? formInfo.referencias[3].titulo
                : 'Número de documento'
            }
            name="docNumber"
            maxLength="25"
            type="number"
            square
            placeholder={
              formInfo.referencias[3].subtitulo
                ? formInfo.referencias[3].subtitulo
                : 'Escribe tu número de documento'
            }
            register={register}
            validationRules={{
              required: {
                value: true,
                message: 'Campo requerido',
              },
              pattern: {
                value: /^[{0-9}]+$/,
                message: 'No se permiten caracteres especiales',
              },
              maxLength: {
                value: 25,
                message: 'El documento no debe superar los 25 dígitos',
              },
              minLength: {
                value: 5,
                message: 'El documento debe tener al menos 5 dígitos',
              },
            }}
            setValue={setValue}
            required
            error={errors.docNumber}
            disabled={isLogged}
          />
        </div>
      )}

      {!isLogged && (
        <div className="m-request-form-shift__checkContainer">
          <aside className="m-request-form-shift__checkContainer__checkbox">
            <input
              className="checkbox"
              type="checkbox"
              {...register('termsOne', {
                required: {
                  value: true,
                  message: 'Campo requerido',
                },
              })}
            />
            <Checkbox
              square
              checkActive={isActiveTermsOne}
              checkClick={() => handleCheckbox('one')}
              className={checkboxClass}
            />
            <label className="label" onClick={() => onAcceptTerms('one')}>
              {`${formInfo.referencias[4].titulo} `}
              <a
                className="link"
                href={formInfo.referencias[4].redireccion}
                target="_blank"
                rel="noopener noreferrer"
              >
                {formInfo.referencias[4].copyBoton}
              </a>
              {` ${formInfo.referencias[4].subtitulo}`}
            </label>
          </aside>
          <aside className="m-request-form-shift__checkContainer__checkbox">
            <input
              className="checkbox"
              type="checkbox"
              {...register('termsTwo', {
                required: {
                  value: true,
                  message: 'Campo requerido',
                },
              })}
            />
            <Checkbox
              square
              checkActive={isActiveTermsTwo}
              checkClick={() => handleCheckbox('two')}
              className={checkboxClass}
            />
            <label className="label" onClick={() => onAcceptTerms('two')}>
              {`${formInfo.referencias[5].titulo} `}
              <a
                className="link"
                href={formInfo.referencias[5].redireccion}
                target="_blank"
                rel="noopener noreferrer"
              >
                {formInfo.referencias[5].copyBoton}
              </a>
              {` ${formInfo.referencias[5].subtitulo}`}
            </label>
          </aside>
        </div>
      )}
    </form>
  );
};

export default RequestFormShift;
